import React, { useState } from "react";
import { Box, Typography, Switch, Button } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import CompanySetupCard from "../../Components/CompanySetupCard/CompanySetupCard";
import risegroupblack from "../../assets/logo/risegroupblack.svg";

function VirtualOfficePage({ onContinue, onBack }) {
  const [incomplete, setIncomplete] = useState(true);
  const handleOpenAccount = () => { };
  const handleContinue = () => {
    localStorage.setItem("activeFormCompanySetup", "isVirtualOfficeCompleted");
    onContinue();
  };
  return (
    <Box sx={{ p: 3, width: "100%", bgcolor: "#fff" }}>
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Virtual Office, real presence
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>

          <Switch
            checked={!incomplete}
            onChange={() => {
              setIncomplete(!incomplete);
              handleContinue();
            }}
            size="small"
          />
          <Typography variant="body2" color="text.secondary" sx={{ mr: 1, fontWeight: 500 }}>
            {incomplete ? "Incomplete" : "Complete"}
          </Typography>
        </Box>
      </Box>

      {/* Description Text */}
      <Typography variant="body1" color="text.primary" sx={{ mb: 3, fontWeight: "450" }}>
        A virtual office is more than just a mailing address - it's a base for
        your business <br /> at a recognized office with professional staff, workspace
        and facilities.
      </Typography>

      {/* RiseGroup Virtual Office Card */}
      <CompanySetupCard
        id={"CLRD"}
        logo={risegroupblack}
        title="Central London Registered Address"
        offer={"Offer: 30% Discount for the first 12 months" || ""}
        body={` We provide our clients with a professional and highly
        sought-after Central London Office Address in EC4A. All mail
        is sent to you via email upon receipt.`}
        icon={LaunchIcon}
        buttonText={"Access Discount"}
        handleOpenAccount={handleOpenAccount}
      />

      {/* Additional Information */}
      <Box sx={{ mt: 4, mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Having a prestigious London address can enhance your company's
          credibility and professional image.
        </Typography>
      </Box>

      {/* Action Buttons */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
        <Button
          variant="outlined"
          color="primary"
          sx={{ mr: 2 }}
          onClick={() => onBack()}
        >
          Back
        </Button>
        <Button variant="contained" color="primary" onClick={handleContinue}>
          Continue
        </Button>
      </Box>
    </Box>
  );
}

export default VirtualOfficePage;
